
document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle
  const t = document.querySelector('[data-menu-toggle]');
  const m = document.querySelector('[data-mobile-menu]');

  if (t && m) {
    t.addEventListener('click', () => {
      m.hidden = !m.hidden;
    });
  }

  // Product gallery thumbnail navigation
  document.querySelectorAll('[data-thumb]').forEach(b => {
    b.addEventListener('click', () => {
      const i = Number(b.dataset.thumb);

      b.closest('.gallery')
        ?.querySelectorAll('.product-image')[i]
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });

      b.closest('.thumbs')
        ?.querySelectorAll('.thumb')
        .forEach(x => {
          x.classList.toggle('active', x === b);
        });
    });
  });

  // 60-minute offer countdown with automatic refresh
  const DURATION = 60 * 60 * 1000;

  document.querySelectorAll('[data-offer-countdown]').forEach(el => {
    const key =
      'madhuram-offer-end-' + (el.dataset.productKey || 'product');

    const output = el.querySelector('[data-countdown-time]');
    const label = el.querySelector('.offer-countdown-label');

    if (!output) return;

    let endAt;

    try {
      const saved = Number(sessionStorage.getItem(key));

      if (
        !saved ||
        !Number.isFinite(saved) ||
        saved <= Date.now()
      ) {
        endAt = Date.now() + DURATION;
        sessionStorage.setItem(key, String(endAt));
      } else {
        endAt = saved;
      }
    } catch (e) {
      endAt = Date.now() + DURATION;
    }

    let timer = null;

    const update = () => {
      const remaining = Math.max(
        0,
        Math.ceil((endAt - Date.now()) / 1000)
      );

      const mins = String(
        Math.floor(remaining / 60)
      ).padStart(2, '0');

      const secs = String(
        remaining % 60
      ).padStart(2, '0');

      output.textContent = `${mins}:${secs}`;

      if (remaining === 0) {
        if (timer !== null) {
          clearInterval(timer);
        }

        if (label) {
          label.textContent = 'Refreshing offer...';
        }

        // Prevent multiple simultaneous refreshes
        if (window.__madhuramReloading) return;

        window.__madhuramReloading = true;

        // Reset all product timers before page refresh
        document.querySelectorAll('[data-offer-countdown]')
          .forEach(item => {
            const itemKey =
              'madhuram-offer-end-' +
              (item.dataset.productKey || 'product');

            try {
              sessionStorage.setItem(
                itemKey,
                String(Date.now() + DURATION)
              );
            } catch (e) {}
          });

        // Automatically refresh the page
        window.location.reload();
      }
    };

    // Start countdown immediately
    update();

    // Update every second
    timer = setInterval(update, 1000);
  });
});
